import { useEffect } from 'react'
import { useMic } from './mic.js'
import { usePermission } from '../audio-permissions.hook.js'

/** Ensure the Mic is started when this hook is in the scope. Disconnect the mic on exit. */
export const useStartMic = () => {
  const { permission } = usePermission('microphone')
  const { start, stop, selectedDevice } = useMic()
  useEffect(() => {
    if (permission !== 'granted') {
      return
    }
    start()
    return () => {
      stop()
    }
  }, [start, stop, selectedDevice, permission])

  return { selectedDevice }
}
